import { render, staticRenderFns } from "./SharePercentage.vue?vue&type=template&id=1d0b902a"
import script from "./SharePercentage.vue?vue&type=script&lang=js"
export * from "./SharePercentage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports